import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Button } from 'react-admin'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router'
import compose from 'recompose/compose'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import CircularProgress from '@material-ui/core/CircularProgress'
import LinearProgress from '@material-ui/core/LinearProgress'
import IconButton from '@material-ui/core/IconButton'
import green from '@material-ui/core/colors/green'
import ButtonIcon from '@material-ui/icons/Description'
import CloseIcon from '@material-ui/icons/Close'

import moment from 'moment'
import _ from 'lodash'
import { saveAs } from 'file-saver'

const styles = theme => ({
    snackbarContent : {
        '& > div' : {
            width : '100%'
        }
        // message : {
        //     width : '100%'
        // }
    },
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    icon: {
        fontSize: 20,
    },
})

const BULK_LOAD_EXCEL_BASE_URL = `${process.env.API_URL}/api/v1/carga_masiva_excel`

class DownloadBulkLoadExcelInstalaciones extends Component {

    state = {
        snackbarOpen : false,
        loading : false,
        message : 'Cargando...',
        task_id : null,
        filename : '',
        progress : 0,
        error : false,
    }
    statusInterval = null

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        this.setState({ snackbarOpen: false });
    }

    get_params_uri = () => {
        const { location } = this.props
        const search = _.get(location, 'search')
        const params = [...new URLSearchParams(search).entries()].reduce((sum, [key,val]) => Object.assign({[key]:val}, sum), {})
        let res = JSON.parse(_.get(params, 'filter', "{}"))
        if(params.sort){
            const prefix = params.order === 'DESC' ? '-' : ''
            res['ordering'] = `${prefix}${params.sort}`
        }
        return Object.keys(res).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(res[k])}`).join('&')
    }

    download_bulkload_excel = () => {
        const { resource } = this.props
        const params = this.get_params_uri()
        const filename = `carga_masiva_${resource}_${moment().format("YYYYDDMMmmss")}.xlsx`
        const accessToken = localStorage.getItem('accessToken')
        let headers = {
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }
        if(!!accessToken){ headers['Authorization'] = `Bearer ${accessToken}` }

        this.setState({ message : "Generando Excel...", loading : true, snackbarOpen : true, error : false })

        fetch(`${BULK_LOAD_EXCEL_BASE_URL}/${resource}/download_excel_instalaciones/${!!params ? '?'+params : ''}`, {
            headers: headers,
            responseType: 'blob'
        })
        .then(response => {
            if(response.ok) {
                return response.blob()
            } else {
                throw Error(response.status)
            }
        })
        .then(blob => {
            this.setState({ message : "Descarga completada", loading : false, snackbarOpen : false })
            saveAs(blob, filename)
        })
        .catch(error => {
            console.error(error)
            this.setState({ loading : false, error : true, message : 'Error al descargar reporte' })
        })
    }

    componentWillUnmount(){
        if(this.statusInterval){
          clearInterval(this.statusInterval)
        }
    }

    render() {
        const { classes } = this.props
        const { snackbarOpen, loading, message, progress, error } = this.state
        return (
            <Fragment>
                <Button 
                    label={!loading ? "Excel Instalaciones" : "Generando Excel"} 
                    onClick={this.download_bulkload_excel} 
                    disabled={loading}
                >
                    {!loading 
                    ? <ButtonIcon/>
                    : <CircularProgress size={20} />
                    }
                </Button>
                <Snackbar
                    anchorOrigin={{ vertical : 'bottom', horizontal : 'right' }}
                    open={snackbarOpen}
                    
                    // onClose={this.handleClose}
                >
                    <SnackbarContent
                        className={!error ? classes.snackbarContent : ''}
                        message={
                            <div>
                                <span id="message-id">{message}</span>
                                <LinearProgress variant="determinate" value={progress} />
                            </div>
                        }
                        action={error && [
                            <IconButton
                              key="close"
                              aria-label="Close"
                              color="inherit"
                            //   className={classes.close}
                              onClick={this.handleClose}
                            >
                              <CloseIcon className={classes.icon} />
                            </IconButton>,
                          ]}
                    />   
                </Snackbar>
            </Fragment>
        )
    }
}

const enhance = compose(
    connect( null, {}),
    withStyles(styles),
    withRouter
)
export default enhance(DownloadBulkLoadExcelInstalaciones)
